import { render, staticRenderFns } from "./TabIngredient.vue?vue&type=template&id=a7d95b26&scoped=true&"
import script from "./TabIngredient.vue?vue&type=script&lang=js&"
export * from "./TabIngredient.vue?vue&type=script&lang=js&"
import style0 from "./TabIngredient.vue?vue&type=style&index=0&id=a7d95b26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d95b26",
  null
  
)

export default component.exports